import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initBlogSort from '../sections/blog/initBlogSort';

ready(() => {
  initBlogSort();
});

onShopifySectionLoad(() => {
  initBlogSort();
});
